import { Component } from '@angular/core';
import { SharedService } from 'src/app/shared/services/shared.service';
import { BottomFooterComponent } from '../bottom-footer/bottom-footer.component';
import { TopNavbarComponent } from '../top-navbar/top-navbar.component';

@Component({
  selector: 'app-about',
  standalone: true,
  templateUrl: './about.component.html',
  styleUrl: './about.component.scss',
  imports: [TopNavbarComponent, BottomFooterComponent]
})
export class AboutComponent {
 constructor(public sharedService: SharedService) {}

   ngOnInit() {}
}
